/*
  This file is used for being able to open the livechat chat from anywhere in the app.
*/
import { Action, action } from "easy-peasy";

export type LiveChatVisiblity =
  | "maximized"
  | "minimized"
  | "hidden"
  | undefined;

export interface LiveChatModel {
  visibility: LiveChatVisiblity;
  setVisibility: Action<LiveChatModel, LiveChatVisiblity>;
}

export const livechat: LiveChatModel = {
  visibility: "minimized",

  setVisibility: action((state, payload: LiveChatVisiblity) => {
    state.visibility = payload;
  }),
};
